import { useEffect, useMemo, useState } from "react";
import { collection, onSnapshot, query, where } from "firebase/firestore";
import { db } from "../firebase";

const getMillis = (ts) => (ts?.toMillis ? ts.toMillis() : 0);

export function useMyBabbleGames(user) {
  const [hostGames, setHostGames] = useState([]);
  const [guestGames, setGuestGames] = useState([]);
  const [hostLoaded, setHostLoaded] = useState(false);
  const [guestLoaded, setGuestLoaded] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!user) {
      setHostGames([]);
      setGuestGames([]);
      setHostLoaded(false);
      setGuestLoaded(false);
      setError(null);
      return;
    }

    const col = collection(db, "games_babble");
    setHostLoaded(false);
    setGuestLoaded(false);

    const unsubHost = onSnapshot(
      query(col, where("hostUid", "==", user.uid)),
      (snap) => {
        setHostGames(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
        setHostLoaded(true);
        setError(null);
      },
      (err) => {
        console.error("[BabbleGames] host", err);
        setError(err.message || "Failed to load Babble games.");
        setHostLoaded(true);
      }
    );

    const unsubGuest = onSnapshot(
      query(col, where("guestUid", "==", user.uid)),
      (snap) => {
        setGuestGames(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
        setGuestLoaded(true);
        setError(null);
      },
      (err) => {
        console.error("[BabbleGames] guest", err);
        setError(err.message || "Failed to load Babble games.");
        setGuestLoaded(true);
      }
    );

    return () => {
      unsubHost();
      unsubGuest();
    };
  }, [user]);

  const games = useMemo(() => {
    const byId = new Map();
    hostGames.forEach((g) => byId.set(g.id, g));
    guestGames.forEach((g) => byId.set(g.id, g));
    return Array.from(byId.values()).sort((a, b) => {
      const aTs = getMillis(a.updatedAt) || getMillis(a.createdAt);
      const bTs = getMillis(b.updatedAt) || getMillis(b.createdAt);
      return bTs - aTs;
    });
  }, [hostGames, guestGames]);

  const loading = !!user && (!(hostLoaded && guestLoaded));

  return {
    games,
    loading,
    error,
  };
}
